module.exports = __webpack_public_path__ + "img/932.666fef0e.png";